export enum LogBookControl {
  SafeHeating = "Safe Heating",
  FailReport = "Fail Report",
  FoodPoisoning = "Food Poisoning",
  ProductReturn = "Product Return",
}
